import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [quantity, setQuantity] = useState(1);
  const [returnsOpen, setReturnsOpen] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleQuantityChange = (type) => {
    if (type === "dec" && quantity > 1) {
      setQuantity(quantity - 1);
    } else if (type === "inc") {
      setQuantity(quantity + 1);
    }
  };

  return (
    <div className="product-detail main">
      <div className="product-detail__left">
        <div className="image-grid">
          {product.images && product.images.length > 0 ? (
            product.images.map((img, idx) => (
              <img key={idx} src={img} alt={`${product.name} ${idx}`} />
            ))
          ) : (
            <img src={product.image} alt={product.name} />
          )}
        </div>
      </div>
      <div className="product-detail__right">
        <div className="brand">{product.brand}</div>
        <h1 className="title">{product.name.toUpperCase()}</h1>
        <div className="price">${product.price} USD</div>

        <div className="description">
          {product.description.map((des, index) => (
            <p key={index}>{des}</p>
          ))}
          <ul>
            {product.Features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="size-selector">
          <div className="label">Size : {selectedSize}</div>
          <div className="options">
            {product.size.map((s) => (
              <button
                key={s}
                className={selectedSize === s ? "active" : ""}
                onClick={() => setSelectedSize(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        <div className="color-selector">
          <div className="label">Colour : {selectedColor.toUpperCase()}</div>
          <div className="options">
            {product.colors.map((c) => (
              <button
                key={c}
                className={selectedColor === c ? "active" : ""}
                onClick={() => setSelectedColor(c)}
                aria-label={`Select ${c}`}
              >
                <span>{c}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="shipping-info">
          <p>
            <strong>$9.99</strong> flat-rate shipping
          </p>
          <p>
            <strong>Support</strong> available at import@cewillowmarket.life
          </p>
        </div>

        <div className="add-to-cart-section">
          <div className="quantity">
            <button onClick={() => handleQuantityChange("dec")}>-</button>
            <span>{quantity}</span>
            <button onClick={() => handleQuantityChange("inc")}>+</button>
          </div>
          <button className="add-btn" onClick={handleAddToCart}>
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            Add to cart
          </button>
        </div>

        <div className="payment-note">Secure payment is completed on our payment page.</div>

        <div className="returns-accordion">
          <button
            className="accordion-header"
            onClick={() => setReturnsOpen(!returnsOpen)}
          >
            RETURNS
            <span>{returnsOpen ? "-" : "+"}</span>
          </button>
          {returnsOpen && (
            <div className="accordion-content">
              <p>
                Returns accepted within <strong>14 days</strong> on eligible
                full priced items. Items must be unused with tags attached. Sale
                items, jewellery and hair accessories are excluded. Refund or
                store credit available.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
